import { useCallback, useContext } from 'react';
import { SnackbarContext, SnackbarType } from '@core/providers/SnackbarProvider';

const DIALOG_AUTO_HIDE_MS = 5000;

const useSnackbar = () => {
  const context = useContext(SnackbarContext);

  if (context === null) {
    throw Error(
      'Context useSnackbar is not available. useSnackbar must be used within a child component of SnackbarProvider',
    );
  }

  const showSnackbar = useCallback(
    ({
      message,
      type = 'default',
      title = 'Info',
      autoHideDuration,
      onClose,
    }: {
      message: string;
      title: string;
      type?: SnackbarType;
      autoHideDuration?: number;
      onClose?: VoidFunction;
    }) => {
      // Success and error are shown as stacked notifications (same as evoadmin-web);
      // the rest keep the confirmation dialog.
      if (type === 'success' || type === 'error') {
        context.addNotification({ message, title, type, autoHideDuration, onClose });
        return;
      }

      const { setOpen, setMessage, setType, setTitle, setAutoHideDuration } = context;

      setMessage(message);
      setType(type);
      setTitle(title);
      setOpen(true);
      setAutoHideDuration(autoHideDuration ?? DIALOG_AUTO_HIDE_MS);
    },
    [context],
  );

  return showSnackbar;
};

export default useSnackbar;
